module.exports = __webpack_public_path__ + "static/media/image-icon.ddcc5ed0.svg";